// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"we_a bhr_b bhr_we"};